export default "__VITE_ASSET__pCu2LSEi__"